import { arrowSwitchIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Transfer = createIcon({
  displayName: 'Transfer',
  paths: [
    'M840.853 339.163l-181.035 181.033c-16.64 16.683-43.648 16.683-60.331 0s-16.683-43.648 0-60.331l108.203-108.201h-494.334c-23.595 0-42.667-19.072-42.667-42.667 0-23.552 19.072-42.667 42.667-42.667h494.334l-108.203-108.16c-16.683-16.683-16.683-43.691 0-60.331 16.683-16.683 43.691-16.683 60.331 0l181.035 180.992c16.64 16.683 16.64 43.691 0 60.331zM424.525 865.826c16.682 16.683 16.682 43.648 0 60.331s-43.648 16.683-60.331 0l-181.035-181.035c-16.64-16.64-16.64-43.648 0-60.331l181.035-180.992c16.683-16.683 43.648-16.683 60.331 0 16.682 16.64 16.682 43.648 0 60.331l-108.203 108.16h494.336c23.595 0 42.667 19.115 42.667 42.667 0 23.595-19.072 42.667-42.667 42.667h-494.336l108.203 108.203z'
  ],
  canvasPaths: canvasIconPaths(arrowSwitchIcon)
})
